import script from "./EmailTagsInput.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTagsInput.vue?vue&type=script&setup=true&lang=js"

import "./EmailTagsInput.vue?vue&type=style&index=0&id=3f801d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f801d63"]])

export default __exports__